import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { BracketItemService } from 'src/app/services/bracket-item.service';
import { DuelSeriesService } from 'src/app/services/duel-series.service';
import { GroupGamesService } from 'src/app/services/group-games.service';
import { DuelSeriesViewComponent } from '../duel-series-view/duel-series-view.component';
import {DuelViewsServiceService} from "../../services/duel-views-service.service";
import {type} from "os";
import {ManualSetPlayersComponent} from "../manual-set-players/manual-set-players.component";
import {DuelEditOrAddModalComponent} from "./duel-edit-or-add-modal/duel-edit-or-add-modal.component";
const STATUS_CLASSNAMES = {
  empty: 'b-match_empty',
  scheduled: 'b-match_scheduled',
  in_progress: 'b-match_in_progress',
  finished: 'b-match_finished',
};

@Component({
  selector: 'app-bracket-item',
  templateUrl: './bracket-item.component.html',
  styleUrls: ['./bracket-item.component.scss'],
})
export class BracketItemComponent implements OnInit {
  @Input() tournamentHasGroups : any;
  @Input() roundName : any;
  @Input() isFirstRound: string;
  @Input() duelSeriesId: number = -1;
  @Input() number: number = -1;
  @Input() table: string = '';
  @Input() scheduledAt: string = '';

  @Input() playerOneId: number | null = null;
  @Input() playerOne: string | null = null;
  @Input() playerOneScore: number | null = null;
  @Input() playerOneTournamentNumber: number | null = null;
  @Input() playerOneCountryCode: number | null = null;

  @Input() playerTwoId: number | null = null;
  @Input() playerTwo: string | null = null;
  @Input() playerTwoScore: number | null = null;
  @Input() playerTwoTournamentNumber: number | null = null;
  @Input() playerTwoCountryCode: number | null = null;

  @Input() hasWalkover: string = '';
  @Input() status: string = '';

  @Input() looserGoesTo: string | null = '';
  @Input() winnerGoesTo: string | null = '';
  @Input() videoLink: string | null = null;


  private _firstPlayerIsWalkOver;

  private _secondPlayerIsWalkOver;

  public has_walkover: boolean = false;
  public looser_goes_to: string = '';
  public winner_goes_to: string = '';

  public highlightPlayerOne: boolean = false;
  public highlightPlayerTwo: boolean = false;

  public highlighted: boolean = false;

  public statusClassName: any = null;

  private highlightDownTier: boolean = false;
  private isFirstFinalPartTier: boolean = false;
  private evenDownTierNumber = 0;
  private highlightClassesDictDownTiers = {
    2: 'secondDownTierNumberColor',
    4: 'fourthDownTierNumberColor',
    6: 'sixthDownTierNumberColor',
  };

  constructor(
    private modalService: NgbModal,
    private bracketItemService: BracketItemService,
    private duelSeriesService: DuelSeriesService,
    private cd: ChangeDetectorRef,
    private duelViewsService: DuelViewsServiceService,
  ) {}

  ngOnInit(): void {
    if (this.videoLink === 'None'){
      this.videoLink = '';
    }
    //this.has_walkover = this.hasWalkover.toLowerCase() == 'true' || this.status == 'finished';
    this.has_walkover = this.hasWalkover.toLowerCase().includes('true');
    this.looser_goes_to = this.looserGoesTo.trim();
    this.winner_goes_to = this.winnerGoesTo.trim();


    this.statusClassName = [this.getStatusClassName()];

    this.bracketItemService.highlightItemEmitter.subscribe((event) => {
      if (event.event == 'off') {
        this.highlightPlayerOne = false;
        this.highlightPlayerTwo = false;
      } else if (event.event == 'on') {
        if (event.player == this.playerOneId) {
          this.highlightPlayerOne = true;
        } else if (event.player == this.playerTwoId) {
          this.highlightPlayerTwo = true;
        }
      }
    });

    this.bracketItemService.highlightDSEmitter.subscribe((event) => {
      if (event.event == 'highlight') {
        if (event.num == this.number) {
          this.highlighted = true;

          setTimeout(() => {
            this.highlighted = false;
            this.cd.detectChanges();
          }, 2000);
        }
      }
    });

    this.bracketItemService.updateEmitter.subscribe((event) => {
      if (event.event == 'update') {
        if (event.id == this.duelSeriesId) {
          this.update();
        }
      } else if (event.event === 'updateAll') {
        this.update();
      }
    });
    this.bracketItemService.setUpFirstRoundNameIndicator(this.roundName);
    this.bracketItemService.updateValues(this.roundName.trim());

    this.setIsFirstFinalPartTier(this.isFirstFinalTier(this.roundName));
    this.setHighlightDownTier(this.isEvenDownTier(this.roundName));
    // console.debug('this is the tier name', this.roundName);
    // console.debug('it is the first finale part tier', this.getIsFirstFinalPartTier());
    // console.debug('it is an even down tier', this.getHighlightDownTier());
    // console.debug(
    //   'names couples: previous and next one',
    //   this.bracketItemService.getPreviousRoundName(),
    //   this.bracketItemService.getNextRoundName()
    // );
  }

  isEmpty(): boolean {
    return (!this.playerOneId && !this.playerTwoId) || !this.playerOneId || !this.playerTwoId;
  }

  getStatusClassName() {
    if (this.isEmpty()) {
      return STATUS_CLASSNAMES['empty'];
    }
    if (this.status && STATUS_CLASSNAMES[this.status]) {
      return STATUS_CLASSNAMES[this.status];
    }
    return '';
  }

  openForManualAssign($event, playerNumber: number) {
    const lstOfPlayersId = [this.playerOneId, this.playerTwoId];

    if (this.tournamentHasGroups == "True" && !lstOfPlayersId[playerNumber - 1] && !!window['iAmStaff']) {
      if (this.has_walkover) {
        $event.stopPropagation();
        const modalRef = this.modalService.open(ManualSetPlayersComponent, {
          size: 'lg',
          windowClass: 'testModalStyle',
          centered: true,
        });
        modalRef.componentInstance.playerOrder = playerNumber;
        modalRef.componentInstance.duelNumber = this.number;
      }
      else {
        const addOrEdit = false
        const modalRef = this.modalService.open(DuelEditOrAddModalComponent, {
          size: 'md',
          windowClass: 'testModalStyle',
          centered: true,
        });
        modalRef.result.then((result) => {
          if (result == 'edit') {
            this.open();
          }
          if (result == 'add') {
            $event.stopPropagation();
            const modalRef = this.modalService.open(ManualSetPlayersComponent, {
              size: 'lg',
              windowClass: 'testModalStyle',
              centered: true,
            });
            modalRef.componentInstance.playerOrder = playerNumber;
            modalRef.componentInstance.duelNumber = this.number;
          }
        });
      }

    }
    else if ((!this.playerOneId && !this.playerTwoId && !window['iAmStaff']))  {
      return;
    }
    else {
      this.open();
    }
  }

  open() {
    if (this.has_walkover) {
      return;
    }
    const modalRef = this.modalService.open(DuelSeriesViewComponent, {
      size: 'lg',
      windowClass: 'testModalStyle',
    });
    this.duelViewsService.duelId = this.duelSeriesId;
    modalRef.componentInstance.id = this.duelSeriesId;
    this.duelViewsService.hasWalkOver = this.has_walkover

    modalRef.result.then(
      () => {
        modalRef.componentInstance.triggerUpdate();
      },
      () => {
        modalRef.componentInstance.triggerUpdate();
      }
    );
  }

  mouseEnter(player: number | null) {
    if (player) {
      this.bracketItemService.hover(player);
    }
  }

  mouseLeave(player: number | null) {
    if (player) {
      this.bracketItemService.leave(player);
    }
  }

  update() {
    this.duelSeriesService.get(this.duelSeriesId).subscribe((ds: any) => {
      this._firstPlayerIsWalkOver = ds?.walkover?.player1_is_walk_over;
      this._secondPlayerIsWalkOver = ds?.walkover?.player2_is_walk_over;

      console.debug('this is the first and the second', this._firstPlayerIsWalkOver, this._secondPlayerIsWalkOver);
      this.playerOneScore = ds?.player_one_score;
      this.playerOne = ds?.player_one?.full_name;
      this.playerOneId = ds?.player_one?.id;
      this.playerOneCountryCode = ds?.player_one?.country_code;
      // if (ds.player_one) {
      //   this.playerOneScore = ds.player_one_score;
      //   this.playerOne = ds.player_one.full_name;
      //   this.playerOneId = ds.player_one.id;
      //   this.playerOneCountryCode = ds.player_one.country_code;
      // }
      this.playerTwoScore = ds?.player_two_score;
      this.playerTwo = ds?.player_two?.full_name;
      this.playerTwoId = ds?.player_two?.id;
      this.playerTwoCountryCode = ds?.player_two?.country_code;
      // if (ds.player_two) {
      //   this.playerTwoScore = ds.player_two_score;
      //   this.playerTwo = ds.player_two.full_name;
      //   this.playerTwoId = ds.player_two.id;
      //   this.playerTwoCountryCode = ds.player_two.country_code;
      // }
      this.has_walkover = ds.walkover;
      this.status = ds.status;
      if (this.has_walkover) {
        ds.child_ids.forEach((id) => {
          this.bracketItemService.update(id);
        });
      }
      this.statusClassName = [this.getStatusClassName()];
      if (ds.status == 'scheduled' && ds.scheduled_at) {
        this.scheduledAt = moment(ds.scheduled_at).format('DD.MM.YYYY, HH:mm');
      }
      if (ds.status != 'scheduled' && ds.played_at) {
        // this.scheduledAt = moment(ds.played_at).format('DD.MM.YYYY, HH:mm');
        this.scheduledAt = moment(ds.played_at).utc().add(ds.played_at.utcOffset(), 'm').format('DD.MM.YYYY, HH:mm');
      }
      this.table = ds.table?.number;
      this.cd.detectChanges();
    });
  }

  scrollTo(num) {
    this.bracketItemService.scrollTo(num);
  }

  private getName(name) {
    const [last_name, first_name] = name.split(' ');

    return `${last_name} ${first_name}`;
  }

  getShortenPlayerName(name) {
    const [last_name, first_name] = name.split(' ');
    if (name && name !== 'Walk Over' && first_name) {
      return `${last_name} ${first_name[0]}.`;
    }

    return name || '—';
  }

  getPlayerOneName() : string {
    return this.playerOne ? this.getName(this.playerOne) : (this._firstPlayerIsWalkOver && 'Walk Over') || '—';
  }

  getPlayerTwoName() : string{
    return this.playerTwo ? this.getName(this.playerTwo) : (this._secondPlayerIsWalkOver && 'Walk Over') || '—';
  }

  showWinner () :boolean {
    const referenceString = 'Низ';
    return this.roundName.indexOf(referenceString) !== -1  && this.roundName === this.bracketItemService.firstRoundNameIndicator;
  };

  showLooser () : boolean {
    const referenceString = 'Верх'
    return this.roundName.indexOf(referenceString) !== -1;
  }

  getHighlightDownTier() {
    return this.highlightDownTier;
  }

  setHighlightDownTier(value) {
    this.highlightDownTier = value;
  }

  getIsFirstFinalPartTier() {
    return this.isFirstFinalPartTier;
  }

  setIsFirstFinalPartTier(value) {
    this.isFirstFinalPartTier = value;
  }

  isEvenDownTier(tierName) {
    const referenceString = 'ни';
    const thirdPlaceTier = '3е';

    if (tierName.toLowerCase().includes(referenceString)) {

      const downTierNumber = parseInt(tierName.split(' ').at(-1));
      this.setEvenDownTierNumber(downTierNumber);

      return !(downTierNumber % 2);
    } else if(tierName.toLowerCase().includes(thirdPlaceTier)) {

      this.setEvenDownTierNumber(6);

      return true;
    }
    return  false;
  }

  isFirstFinalTier(tierName) {
    const referenceString = 'верх';

    return !tierName.toLowerCase().includes(referenceString)
      && this.bracketItemService.getPreviousRoundName().toLowerCase().includes(referenceString);
  }

  tierNumberHighlightClass() {

    return this.getIsFirstFinalPartTier()
      ? 'firstFinalTierNumberStyle'
      : this.highlightClassesDictDownTiers[this.getEvenDownTierNumber()] || '';
  }

  getEvenDownTierNumber() {
    return this.evenDownTierNumber;
  }

  setEvenDownTierNumber(num) {
    this.evenDownTierNumber = num;
  }
}
